var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8,4.8c0,0-0.2-1.1-0.6-1.6c-0.6-0.6-1.3-0.6-1.6-0.7C11.4,2.4,8,2.4,8,2.4h0c0,0-3.4,0-5.6,0.2c-0.3,0-1,0-1.6,0.7\n\tC0.3,3.7,0.2,4.8,0.2,4.8S0,6.1,0,7.4v1.2c0,1.3,0.2,2.6,0.2,2.6s0.2,1.1,0.6,1.6c0.6,0.6,1.4,0.6,1.8,0.7C3.8,13.6,8,13.6,8,13.6\n\ts3.4,0,5.6-0.2c0.3,0,1,0,1.6-0.7c0.5-0.5,0.6-1.6,0.6-1.6S16,9.9,16,8.6V7.4C16,6.1,15.8,4.8,15.8,4.8L15.8,4.8z M6.3,10.1V5.6\n\tl4.3,2.3C10.7,7.8,6.3,10.1,6.3,10.1z","fill":"currentColor"}));
}

Youtube.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Youtube;

Youtube.default = Youtube;
